import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var NAVIGATION_TREE_HASH_CODE_PROPERTY_NAME = "navigationTreeHashCode";
export var getNavigationTreeHashCode = function() {
    return getGlobalProperty(NAVIGATION_TREE_HASH_CODE_PROPERTY_NAME);
};
